import { render } from "./EcoWedding.vue?vue&type=template&id=178a65d6&scoped=true"
import script from "./EcoWedding.vue?vue&type=script&lang=js"
export * from "./EcoWedding.vue?vue&type=script&lang=js"

import "./EcoWedding.vue?vue&type=style&index=0&id=178a65d6&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178a65d6"]])

export default __exports__